import {ResolutionTime} from "../telematics/components/Colorizer/ResolutionTime";
import {ResolutionDate} from "../telematics/components/Colorizer/ResolutionDate";
import type {Job} from "./Job";
import {z} from "zod";


export class JobValidator {

    static checkAll(job: Job): boolean {
        return JobValidator.checkStartEndOfTimeWindow(job) &&
            JobValidator.checkTargetDateBetweenEarliestLatestDeliveryDate(job) &&
            JobValidator.checkEarliestBeforeLatestDeliveryDate(job) &&
            JobValidator.checkTargetDateAfterEarliestDeliveryDate(job) &&
            JobValidator.checkTargetDateBeforeLatestDeliveryDate(job) &&
            JobValidator.checkCityNotEmpty(job) &&
            JobValidator.checkStreetNotEmpty(job) &&
            JobValidator.checkFillPercentageBetween0And100(job) &&
            JobValidator.checkNumberOfParcelsIsPositive(job) &&
            JobValidator.checkIfTotalWeightIsPositive(job);
    }

    static checkStartEndOfTimeWindow(job: Job): boolean {
        if (job.getStartOfTimeWindow() && job.getEndOfTimeWindow()) {
            let start = ResolutionTime.getMinutesFromHourString(job.getStartOfTimeWindow());
            let end = ResolutionTime.getMinutesFromHourString(job.getEndOfTimeWindow());
            if (start > end) {
                return false;
            }
        }
        return true;
    }

    static checkTargetDateBetweenEarliestLatestDeliveryDate(job: Job): boolean {
        if (job.getEarliestDeliveryDate() && job.getLatestDeliveryDate() && job.getTargetDate()!==null) {
            let earliest = new Date(job.getEarliestDeliveryDate());
            let latest = new Date(job.getLatestDeliveryDate());
            let target = new Date(job.getTargetDate());
            if (target < earliest || target > latest) {
                return false;
            }
        }
        return true;
    }

    static checkEarliestBeforeLatestDeliveryDate(job: Job): boolean {
        if (job.getEarliestDeliveryDate() && job.getLatestDeliveryDate()) {
            let earliest = new Date(job.getEarliestDeliveryDate());
            let latest = new Date(job.getLatestDeliveryDate());
            if (earliest > latest) {
                return false;
            }
        }
        return true;
    }

    static checkTargetDateAfterEarliestDeliveryDate(job: Job): boolean {
        if (job.getEarliestDeliveryDate() && job.getTargetDate()!==null) {
            let earliest = ResolutionDate.getDaysFromDate( new Date(job.getEarliestDeliveryDate()) );
            let target = ResolutionDate.getDaysFromDate( new Date(job.getTargetDate()) );
            if (target < earliest) {
                return false;
            }
        }
        return true;
    }

    static checkTargetDateBeforeLatestDeliveryDate(job: Job): boolean {
        if (job.getLatestDeliveryDate() && job.getTargetDate()!==null) {
            let latest = ResolutionDate.getDaysFromDate( new Date(job.getLatestDeliveryDate()) );
            let target = ResolutionDate.getDaysFromDate( new Date(job.getTargetDate()) );
            if (target > latest) {
                return false;
            }
        }
        return true;
    }

    static checkCityNotEmpty(job: Job): boolean {
        if (!job.getData()?.address_attributes?.city) {
            return false;
        }
        return true;
    }

    static checkStreetNotEmpty(job: Job): boolean {
        if (!job.getData()?.address_attributes?.street) {
            return false;
        }
        return true;
    }

    static checkFillPercentageBetween0And100(job: Job): boolean {
        if (job.getData()?.special_attributes?.fill_percentage) {
            let fillPercentage = z.coerce.number().safeParse(job.getData()?.special_attributes?.fill_percentage);
            if (fillPercentage.success === false || fillPercentage.data < 0 || fillPercentage.data > 100) {
                return false;
            }
        }
        return true;
    }

    static checkNumberOfParcelsIsPositive(job: Job): boolean {
        if (job.getData()?.special_attributes?.parcels) {
            if (z.coerce.number().min(1).safeParse(job.getData()?.special_attributes?.parcels).success === false) {
                return false;
            }
        }
        return true;
    }

    static checkIfTotalWeightIsPositive(job: Job): boolean {
        if (job.getData()?.special_attributes?.total_weight) {
            if (z.coerce.number().min(0).safeParse(job.getData()?.special_attributes?.total_weight).success === false) {
                return false;
            }
        }
        return true;
    }

}